export default {
  provide() {
    return {
      operator: this,
    }
  },

  props: {
    data: [Object, Array, Boolean, String, Number],

    successMessage: String,
  },

  methods: {
    onClose(data, event = 'success') {
      if (this.successMessage) {
        this.$nextTick(() => this.$Message.success(this.successMessage))
      }

      this.$emit(event, data)
    },

    onCancel() {
      this.$emit('cancel')
    },
  },
}
